<template>

  <article class="c-article__slider c-slider">
    <div class="c-slider__list js-slider" ref="slider">
      <div v-if="content.styling == 'organicSlider'">
        <Shape :slider="true" :img="content.images[activeSlide]" :imgOverlay="false" :bg="true" :id="Math.random().toString(36).substring(7)" />
      </div>
      <div v-else-if="content.styling == 'rectangleSlider'">
        <img :slider="true" class="c-slider__image" :src="content.images[activeSlide].url" alt="">
      </div>
    </div>

    <div class="c-slider__controls" :class="content.styling == 'rectangleSlider' ? 'c_slider__controls--bg' : ''" v-if="content.images.length > 1">
      <div class="c-slider__control" data-control="prev" @click.prevent="goToSlide('prev')">
        <span></span>
      </div>
      <div class="c-slider__pagination">
        <span class="c-slider__current-slide">{{ activeSlide + 1 }}</span>
        <span>/</span>
        <span class="c-slider__all-sides">{{ content.images.length }}</span>
      </div>
      <div class="c-slider__control" @click.prevent="goToSlide('next')">
        <span></span>
      </div>
    </div>
  </article>

</template>

<script>
import Shape from '@/components/Shape'

export default {
  name: 'Slider',
  props: ['content'],

  data () {
    return {
      activeSlide: 0
    }
  },

  methods: {
    goToSlide (dir) {
      if (dir === 'prev') {
        if (this.activeSlide === 0) {
          this.activeSlide = this.content.images.length - 1
        } else this.activeSlide--
      } else {
        if (this.activeSlide === (this.content.images.length - 1)) {
          this.activeSlide = 0
        } else this.activeSlide++
      }
    }
  },

  components: {
    Shape
  }
}
</script>
